module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_5_3_4.46e18f62.jpeg";